function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isArray, isNumber, isObject } from 'vega-util';
import { isBinning } from '../../bin';
import { ANGLE, COLOR, FILL, FILLOPACITY, getOffsetScaleChannel, getSizeChannel, isXorY, isXorYOffset, OPACITY, RADIUS, SCALE_CHANNELS, SHAPE, SIZE, STROKE, STROKEDASH, STROKEOPACITY, STROKEWIDTH, THETA, X, XOFFSET, Y, YOFFSET, TIME } from '../../channel';
import { getBandPosition, getFieldOrDatumDef, isFieldDef, isFieldOrDatumDef } from '../../channeldef';
import { getViewConfigDiscreteSize, getViewConfigDiscreteStep } from '../../config';
import { DataSourceType } from '../../data';
import { channelHasFieldOrDatum } from '../../encoding';
import * as log from '../../log';
import { channelScalePropertyIncompatability, hasContinuousDomain, hasDiscreteDomain, isContinuousToDiscrete, isExtendedScheme, scaleTypeSupportProperty } from '../../scale';
import { getStepFor, isStep } from '../../spec/base';
import { isDiscrete } from '../../type';
import * as util from '../../util';
import { isSignalRef } from '../../vega.schema';
import { exprFromSignalRefOrValue, signalOrStringValue } from '../common';
import { getBinSignalName } from '../data/bin';
import { SignalRefWrapper } from '../signal';
import { makeExplicit, makeImplicit } from '../split';
import { durationExpr } from '../../timeunit';
import { isFacetModel } from '../model';
export var RANGE_PROPERTIES = ['range', 'scheme'];
export function parseUnitScaleRange(model) {
  var localScaleComponents = model.component.scales;
  // use SCALE_CHANNELS instead of scales[channel] to ensure that x, y come first!
  var _iterator = _createForOfIteratorHelper(SCALE_CHANNELS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var channel = _step.value;
      var localScaleCmpt = localScaleComponents[channel];
      if (!localScaleCmpt) {
        continue;
      }
      var rangeWithExplicit = parseRangeForChannel(channel, model);
      localScaleCmpt.setWithExplicit('range', rangeWithExplicit);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function getBinStepSignal(model, channel) {
  var fieldDef = model.fieldDef(channel);
  if (fieldDef !== null && fieldDef !== void 0 && fieldDef.bin) {
    var bin = fieldDef.bin,
      field = fieldDef.field;
    var sizeType = getSizeChannel(channel);
    var sizeSignal = model.getName(sizeType);
    if (isObject(bin) && bin.binned && bin.step !== undefined) {
      return new SignalRefWrapper(function () {
        var scaleName = model.scaleName(channel);
        var binCount = "(domain(\"".concat(scaleName, "\")[1] - domain(\"").concat(scaleName, "\")[0]) / ").concat(bin.step);
        return "".concat(model.getSignalName(sizeSignal), " / (").concat(binCount, ")");
      });
    } else if (isBinning(bin)) {
      var binSignal = getBinSignalName(model, field, bin);
      // TODO: extract this to be range step signal
      return new SignalRefWrapper(function () {
        var updatedName = model.getSignalName(binSignal);
        var binCount = "(".concat(updatedName, ".stop - ").concat(updatedName, ".start) / ").concat(updatedName, ".step");
        return "".concat(model.getSignalName(sizeSignal), " / (").concat(binCount, ")");
      });
    }
  }
  return undefined;
}
/**
 * Return mixins that includes one of the Vega range types (explicit range, range.step, range.scheme).
 */
export function parseRangeForChannel(channel, model) {
  var specifiedScale = model.specifiedScales[channel];
  var size = model.size;
  var mergedScaleCmpt = model.getScaleComponent(channel);
  var scaleType = mergedScaleCmpt.get('type');
  // Check if any of the range properties is specified.
  // If so, check if it is compatible and make sure that we only output one of the properties
  var _iterator2 = _createForOfIteratorHelper(RANGE_PROPERTIES),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var property = _step2.value;
      if (specifiedScale[property] !== undefined) {
        var supportedByScaleType = scaleTypeSupportProperty(scaleType, property);
        var channelIncompatability = channelScalePropertyIncompatability(channel, property);
        if (!supportedByScaleType) {
          log.warn(log.message.scalePropertyNotWorkWithScaleType(scaleType, property, channel));
        } else if (channelIncompatability) {
          // channel
          log.warn(channelIncompatability);
        } else {
          switch (property) {
            case 'range':
              {
                var range = specifiedScale.range;
                if (isArray(range)) {
                  if (isXorY(channel)) {
                    return makeExplicit(range.map(function (v) {
                      if (v === 'width' || v === 'height') {
                        // get signal for width/height
                        // Just like default range logic below, we use SignalRefWrapper to account for potential merges and renames.
                        var sizeSignal = model.getName(v);
                        var getSignalName = model.getSignalName.bind(model);
                        return SignalRefWrapper.fromName(getSignalName, sizeSignal);
                      }
                      return v;
                    }));
                  }
                } else if (isObject(range)) {
                  return makeExplicit({
                    data: model.requestDataName(DataSourceType.Main),
                    field: range.field,
                    sort: {
                      op: 'min',
                      field: model.vgField(channel)
                    }
                  });
                }
                return makeExplicit(range);
              }
            case 'scheme':
              return makeExplicit(parseScheme(specifiedScale[property]));
          }
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var sizeChannel = channel === X || channel === 'xOffset' ? 'width' : 'height';
  var sizeValue = size[sizeChannel];
  if (isStep(sizeValue)) {
    if (isXorY(channel)) {
      if (hasDiscreteDomain(scaleType)) {
        var step = getPositionStep(sizeValue, model, channel);
        // Need to be explicit so layer with step wins over layer without step
        if (step) {
          return makeExplicit({
            step: step
          });
        }
      } else {
        log.warn(log.message.stepDropped(sizeChannel));
      }
    } else if (isXorYOffset(channel)) {
      var positionChannel = channel === XOFFSET ? 'x' : 'y';
      var positionScaleCmpt = model.getScaleComponent(positionChannel);
      var positionScaleType = positionScaleCmpt.get('type');
      if (positionScaleType === 'band') {
        var _step3 = getOffsetStep(sizeValue, scaleType);
        if (_step3) {
          return makeExplicit(_step3);
        }
      }
    }
  }
  var rangeMin = specifiedScale.rangeMin,
    rangeMax = specifiedScale.rangeMax;
  var d = defaultRange(channel, model);
  if ((rangeMin !== undefined || rangeMax !== undefined) &&
  // it's ok to check just rangeMin's compatibility since rangeMin/rangeMax are the same
  scaleTypeSupportProperty(scaleType, 'rangeMin') && isArray(d) && d.length === 2) {
    return makeExplicit([rangeMin !== null && rangeMin !== void 0 ? rangeMin : d[0], rangeMax !== null && rangeMax !== void 0 ? rangeMax : d[1]]);
  }
  return makeImplicit(d);
}
function parseScheme(scheme) {
  if (isExtendedScheme(scheme)) {
    return _objectSpread({
      scheme: scheme.name
    }, util.omit(scheme, ['name']));
  }
  return {
    scheme: scheme
  };
}
function fullWidthOrHeightRange(channel, model, scaleType) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    center = _ref.center;
  // If step is null, use zero to width or height.
  // Note that we use SignalRefWrapper to account for potential merges and renames.
  var sizeType = getSizeChannel(channel);
  var sizeSignal = model.getName(sizeType);
  var getSignalName = model.getSignalName.bind(model);
  if (channel === Y && hasContinuousDomain(scaleType)) {
    // For y continuous scale, we have to start from the height as the bottom part has the max value.
    return center ? [SignalRefWrapper.fromName(function (name) {
      return "".concat(getSignalName(name), "/2");
    }, sizeSignal), SignalRefWrapper.fromName(function (name) {
      return "-".concat(getSignalName(name), "/2");
    }, sizeSignal)] : [SignalRefWrapper.fromName(getSignalName, sizeSignal), 0];
  } else {
    return center ? [SignalRefWrapper.fromName(function (name) {
      return "-".concat(getSignalName(name), "/2");
    }, sizeSignal), SignalRefWrapper.fromName(function (name) {
      return "".concat(getSignalName(name), "/2");
    }, sizeSignal)] : [0, SignalRefWrapper.fromName(getSignalName, sizeSignal)];
  }
}
function defaultRange(channel, model) {
  var size = model.size,
    config = model.config,
    mark = model.mark,
    encoding = model.encoding;
  var _getFieldOrDatumDef = getFieldOrDatumDef(encoding[channel]),
    type = _getFieldOrDatumDef.type;
  var mergedScaleCmpt = model.getScaleComponent(channel);
  var scaleType = mergedScaleCmpt.get('type');
  var _model$specifiedScale = model.specifiedScales[channel],
    domain = _model$specifiedScale.domain,
    domainMid = _model$specifiedScale.domainMid;
  switch (channel) {
    case X:
    case Y:
      {
        // If there is no explicit width/height for discrete x/y scales
        if (util.contains(['point', 'band'], scaleType)) {
          var positionSize = getDiscretePositionSize(channel, size, config.view);
          if (isStep(positionSize)) {
            var step = getPositionStep(positionSize, model, channel);
            return {
              step: step
            };
          }
        }
        return fullWidthOrHeightRange(channel, model, scaleType);
      }
    case XOFFSET:
    case YOFFSET:
      return getOffsetRange(channel, model, scaleType);
    case SIZE:
      {
        // TODO: support custom rangeMin, rangeMax
        var rangeMin = sizeRangeMin(mark, config);
        var rangeMax = sizeRangeMax(mark, size, model, config);
        if (isContinuousToDiscrete(scaleType)) {
          return interpolateRange(rangeMin, rangeMax, defaultContinuousToDiscreteCount(scaleType, config, domain, channel));
        } else {
          return [rangeMin, rangeMax];
        }
      }
    case THETA:
      return [0, Math.PI * 2];
    case ANGLE:
      // TODO: add config.scale.min/maxAngleDegree (for point and text) and config.scale.min/maxAngleRadian (for arc) once we add arc marks.
      // (It's weird to add just config.scale.min/maxAngleDegree for now)
      return [0, 360];
    case RADIUS:
      {
        // max radius = half od min(width,height)
        return [0, new SignalRefWrapper(function () {
          var w = model.getSignalName(isFacetModel(model.parent) ? 'child_width' : 'width');
          var h = model.getSignalName(isFacetModel(model.parent) ? 'child_height' : 'height');
          return "min(".concat(w, ",").concat(h, ")/2");
        })];
      }
    case TIME:
      {
        // if (scaleType === 'band') {
        return {
          step: 1000 / config.scale.framesPerSecond
        };
        // }
        // return [0, config.scale.animationDuration * 1000]; // TODO(jzong): uncomment for linear scales when interpolation is implemented
      }
    case STROKEWIDTH:
      // TODO: support custom rangeMin, rangeMax
      return [config.scale.minStrokeWidth, config.scale.maxStrokeWidth];
    case STROKEDASH:
      return [
      // TODO: add this to Vega's config.range?
      [1, 0], [4, 2], [2, 1], [1, 1], [1, 2, 4, 2]];
    case SHAPE:
      return 'symbol';
    case COLOR:
    case FILL:
    case STROKE:
      if (scaleType === 'ordinal') {
        // Only nominal data uses ordinal scale by default
        return type === 'nominal' ? 'category' : 'ordinal';
      } else {
        if (domainMid !== undefined) {
          return 'diverging';
        } else {
          return mark === 'rect' || mark === 'geoshape' ? 'heatmap' : 'ramp';
        }
      }
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
      // TODO: support custom rangeMin, rangeMax
      return [config.scale.minOpacity, config.scale.maxOpacity];
  }
}
function getPositionStep(step, model, channel) {
  var encoding = model.encoding;
  var mergedScaleCmpt = model.getScaleComponent(channel);
  var offsetChannel = getOffsetScaleChannel(channel);
  var offsetDef = encoding[offsetChannel];
  var stepFor = getStepFor({
    step: step,
    offsetIsDiscrete: isFieldOrDatumDef(offsetDef) && isDiscrete(offsetDef.type)
  });
  if (stepFor === 'offset' && channelHasFieldOrDatum(encoding, offsetChannel)) {
    var _mergedScaleCmpt$get;
    var offsetScaleCmpt = model.getScaleComponent(offsetChannel);
    var offsetScaleName = model.scaleName(offsetChannel);
    var stepCount = "domain('".concat(offsetScaleName, "').length");
    if (offsetScaleCmpt.get('type') === 'band') {
      var _ref2, _offsetScaleCmpt$get, _ref3, _offsetScaleCmpt$get2;
      var offsetPaddingInner = (_ref2 = (_offsetScaleCmpt$get = offsetScaleCmpt.get('paddingInner')) !== null && _offsetScaleCmpt$get !== void 0 ? _offsetScaleCmpt$get : offsetScaleCmpt.get('padding')) !== null && _ref2 !== void 0 ? _ref2 : 0;
      var offsetPaddingOuter = (_ref3 = (_offsetScaleCmpt$get2 = offsetScaleCmpt.get('paddingOuter')) !== null && _offsetScaleCmpt$get2 !== void 0 ? _offsetScaleCmpt$get2 : offsetScaleCmpt.get('padding')) !== null && _ref3 !== void 0 ? _ref3 : 0;
      stepCount = "bandspace(".concat(stepCount, ", ").concat(offsetPaddingInner, ", ").concat(offsetPaddingOuter, ")");
    }
    var paddingInner = (_mergedScaleCmpt$get = mergedScaleCmpt.get('paddingInner')) !== null && _mergedScaleCmpt$get !== void 0 ? _mergedScaleCmpt$get : mergedScaleCmpt.get('padding');
    return {
      signal: "".concat(step.step, " * ").concat(stepCount, " / (1-").concat(exprFromSignalRefOrValue(paddingInner), ")")
    };
  } else {
    return step.step;
  }
}
function getOffsetStep(step, offsetScaleType) {
  var stepFor = getStepFor({
    step: step,
    offsetIsDiscrete: hasDiscreteDomain(offsetScaleType)
  });
  if (stepFor === 'offset') {
    return {
      step: step.step
    };
  }
  return undefined;
}
function getOffsetRange(channel, model, offsetScaleType) {
  var positionChannel = channel === XOFFSET ? 'x' : 'y';
  var positionScaleCmpt = model.getScaleComponent(positionChannel);
  if (!positionScaleCmpt) {
    return fullWidthOrHeightRange(positionChannel, model, offsetScaleType, {
      center: true
    });
  }
  var positionScaleType = positionScaleCmpt.get('type');
  var positionScaleName = model.scaleName(positionChannel);
  var markDef = model.markDef,
    config = model.config;
  if (positionScaleType === 'band') {
    var size = getDiscretePositionSize(positionChannel, model.size, model.config.view);
    if (isStep(size)) {
      // step is for offset
      var step = getOffsetStep(size, offsetScaleType);
      if (step) {
        return step;
      }
    }
    // otherwise use the position
    return [0, {
      signal: "bandwidth('".concat(positionScaleName, "')")
    }];
  } else {
    // continuous scale
    var positionDef = model.encoding[positionChannel];
    if (isFieldDef(positionDef) && positionDef.timeUnit) {
      var duration = durationExpr(positionDef.timeUnit, function (expr) {
        return "scale('".concat(positionScaleName, "', ").concat(expr, ")");
      });
      var padding = model.config.scale.bandWithNestedOffsetPaddingInner;
      var bandPositionOffset = getBandPosition({
        fieldDef: positionDef,
        markDef: markDef,
        config: config
      }) - 0.5;
      var bandPositionOffsetExpr = bandPositionOffset !== 0 ? " + ".concat(bandPositionOffset) : '';
      if (padding) {
        var startRatio = isSignalRef(padding) ? "".concat(padding.signal, "/2") + bandPositionOffsetExpr : "".concat(padding / 2 + bandPositionOffset);
        var endRatio = isSignalRef(padding) ? "(1 - ".concat(padding.signal, "/2)") + bandPositionOffsetExpr : "".concat(1 - padding / 2 + bandPositionOffset);
        return [{
          signal: "".concat(startRatio, " * (").concat(duration, ")")
        }, {
          signal: "".concat(endRatio, " * (").concat(duration, ")")
        }];
      }
      return [0, {
        signal: duration
      }];
    }
    return util.never("Cannot use ".concat(channel, " scale if ").concat(positionChannel, " scale is not discrete."));
  }
}
function getDiscretePositionSize(channel, size, viewConfig) {
  var sizeChannel = channel === X ? 'width' : 'height';
  var sizeValue = size[sizeChannel];
  if (sizeValue) {
    return sizeValue;
  }
  return getViewConfigDiscreteSize(viewConfig, sizeChannel);
}
export function defaultContinuousToDiscreteCount(scaleType, config, domain, channel) {
  switch (scaleType) {
    case 'quantile':
      return config.scale.quantileCount;
    case 'quantize':
      return config.scale.quantizeCount;
    case 'threshold':
      if (domain !== undefined && isArray(domain)) {
        return domain.length + 1;
      } else {
        log.warn(log.message.domainRequiredForThresholdScale(channel));
        // default threshold boundaries for threshold scale since domain has cardinality of 2
        return 3;
      }
  }
}
/**
 * Returns the linear interpolation of the range according to the cardinality
 *
 * @param rangeMin start of the range
 * @param rangeMax end of the range
 * @param cardinality number of values in the output range
 */
export function interpolateRange(rangeMin, rangeMax, cardinality) {
  // always return a signal since it's better to compute the sequence in Vega later
  var f = function f() {
    var rMax = signalOrStringValue(rangeMax);
    var rMin = signalOrStringValue(rangeMin);
    var step = "(".concat(rMax, " - ").concat(rMin, ") / (").concat(cardinality, " - 1)");
    return "sequence(".concat(rMin, ", ").concat(rMax, " + ").concat(step, ", ").concat(step, ")");
  };
  if (isSignalRef(rangeMax)) {
    return new SignalRefWrapper(f);
  } else {
    return {
      signal: f()
    };
  }
}
function sizeRangeMin(mark, config) {
  switch (mark) {
    case 'bar':
    case 'tick':
      return config.scale.minBandSize;
    case 'line':
    case 'trail':
    case 'rule':
      return config.scale.minStrokeWidth;
    case 'text':
      return config.scale.minFontSize;
    case 'point':
    case 'square':
    case 'circle':
      return config.scale.minSize;
  }
  /* istanbul ignore next: should never reach here */
  // sizeRangeMin not implemented for the mark
  throw new Error(log.message.incompatibleChannel('size', mark));
}
export var MAX_SIZE_RANGE_STEP_RATIO = 0.95;
function sizeRangeMax(mark, size, model, config) {
  var xyStepSignals = {
    x: getBinStepSignal(model, 'x'),
    y: getBinStepSignal(model, 'y')
  };
  switch (mark) {
    case 'bar':
    case 'tick':
      {
        if (config.scale.maxBandSize !== undefined) {
          return config.scale.maxBandSize;
        }
        var min = minXYStep(size, xyStepSignals, config.view);
        if (isNumber(min)) {
          return min - 1;
        } else {
          return new SignalRefWrapper(function () {
            return "".concat(min.signal, " - 1");
          });
        }
      }
    case 'line':
    case 'trail':
    case 'rule':
      return config.scale.maxStrokeWidth;
    case 'text':
      return config.scale.maxFontSize;
    case 'point':
    case 'square':
    case 'circle':
      {
        if (config.scale.maxSize) {
          return config.scale.maxSize;
        }
        var pointStep = minXYStep(size, xyStepSignals, config.view);
        if (isNumber(pointStep)) {
          return Math.pow(MAX_SIZE_RANGE_STEP_RATIO * pointStep, 2);
        } else {
          return new SignalRefWrapper(function () {
            return "pow(".concat(MAX_SIZE_RANGE_STEP_RATIO, " * ").concat(pointStep.signal, ", 2)");
          });
        }
      }
  }
  /* istanbul ignore next: should never reach here */
  // sizeRangeMax not implemented for the mark
  throw new Error(log.message.incompatibleChannel('size', mark));
}
/**
 * @returns {number} Range step of x or y or minimum between the two if both are ordinal scale.
 */
function minXYStep(size, xyStepSignals, viewConfig) {
  var widthStep = isStep(size.width) ? size.width.step : getViewConfigDiscreteStep(viewConfig, 'width');
  var heightStep = isStep(size.height) ? size.height.step : getViewConfigDiscreteStep(viewConfig, 'height');
  if (xyStepSignals.x || xyStepSignals.y) {
    return new SignalRefWrapper(function () {
      var exprs = [xyStepSignals.x ? xyStepSignals.x.signal : widthStep, xyStepSignals.y ? xyStepSignals.y.signal : heightStep];
      return "min(".concat(exprs.join(', '), ")");
    });
  }
  return Math.min(widthStep, heightStep);
}